import React from 'react';
import {connect} from 'react-redux';
import DeliveryMethod from './DeliveryMethod';
import {transactionType} from '../../Page/TransactionSummaryPage/Shared/Constants';

const DeliveryMethodBlock = ({data, context, deliveryMethod, dealType, isCustomerNeedToReturnEquipment = false}) => {
  let component = <div></div>;

  if (dealType === transactionType.Disconnect) {
    if (isCustomerNeedToReturnEquipment) {
      component = <DeliveryMethod data={data} context={context} deliveryMethod={deliveryMethod} dealType={dealType} />;
    }
  } else {
    component = <DeliveryMethod data={data} context={context} deliveryMethod={deliveryMethod} dealType={dealType} />;
  }
  return component;
};

const mapStateToProps = (state) => {
  return {
    deliveryMethod: state.cellcomTransactionSummary.transactionData.deliveryMethod,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    isCustomerNeedToReturnEquipment:
      state.cellcomTransactionSummary.transactionData.disconnectedServicesAndEquipments?.isCustomerNeedToReturnEquipment,
  };
};

export default connect(mapStateToProps, null)(DeliveryMethodBlock);
